import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc1039',
    ecrans: ['00-2']
});
